import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!

  return (_openBlock(), _createBlock(_component_MultiSelect, {
    ref: "regionDropdown",
    label: "Region",
    placeholder: " ",
    class: "CampaignEditorDropdown",
    options: _ctx.options,
    onUpdated: _ctx.setRegion
  }, null, 8 /* PROPS */, ["options", "onUpdated"]))
}